import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ThreeBarsIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <rect fill="currentColor" height="12" rx="1" transform="matrix(-1 0 0 1 13.5 2)" width="2" />
    <rect fill="currentColor" height="8" rx="1" transform="matrix(-1 0 0 1 9 6)" width="2" />
    <rect fill="currentColor" height="4" rx="1" transform="matrix(-1 0 0 1 4.5 10)" width="2" />
  </svg>
);
